module.exports=[
  {
    "candidate": "Eric Brakey",
    "Brakey": .0,
    "Bennett": .28,
    "Crafts": .25
  },
  {
    "candidate": "Adrienne Bennett",
    "Brakey": .33,
    "Bennett": .0,
    "Crafts": .45
  },{
    "candidate": "Dale Crafts",
    "Brakey": .40,
    "Bennett": .46,
    "Crafts": .0
  },
  {
    "candidate": "undecided",
    "Brakey": .27,
    "Bennett": .25,
    "Crafts": .30
  }
]
